export default __webpack_public_path__ + "static/media/c4c_580x340.1bf74a21.jpg";